import { Component, OnInit, ViewChildren, AfterViewInit, QueryList, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute} from '@angular/router';
/*App imports*/
import { ReportsHelperService } from '../../services/tools/reports-helpers.service';
import { CreditosKeys } from '../../services/tools/helpers.service';
import { ColocadosGeneralComponent } from './components/reporte-general/colocados-general.component';
import { ColocadosHipotecariosComponent } from './components/hipotecarios/colocados-hipotecarios.component';
import { ColocadosAutomotricesComponent } from './components/automotrices/colocados-automotrices.component';
import { ColocadosPrendariosComponent } from './components/prendarios/colocados-prendarios.component';
import { ColocadosVerdesComponent } from './components/verdes/colocados-verdes.component';
import { ColocadosPersonalesComponent } from './components/personales/colocados-personales.component';
import { ColocadosNominasComponent } from './components/nominas/colocados-nominas.component';
import { ColocadosCarburacionesComponent } from './components/carburaciones/colocados-carburaciones.component';
import { ColocadosEstacionariosComponent } from './components/estacionarios/colocados-estacionarios.component';

@Component({
    selector: 'reporte-colocados',
    templateUrl: './reporte-colocados.component.html'
  })

export class ReporteColocadosComponent implements OnInit, AfterViewInit {
    @ViewChildren('colocadosHipotecario') hipotecarioComp : QueryList<ColocadosHipotecariosComponent>;
    public colocadosHipotecario: ColocadosHipotecariosComponent;
    @ViewChildren('colocadosGeneral') generalComp : QueryList<ColocadosGeneralComponent>;
    public colocadosGeneral: ColocadosGeneralComponent;
    @ViewChildren('colocadosAutomotriz') automotrizComp : QueryList<ColocadosAutomotricesComponent>;
    public colocadosAutomotriz: ColocadosAutomotricesComponent;
    @ViewChildren('colocadosPrendarios') prendariosComp : QueryList<ColocadosPrendariosComponent>;
    public colocadosPrendarios: ColocadosPrendariosComponent;
    @ViewChildren('colocadosVerdes') verdesComp : QueryList<ColocadosVerdesComponent>;
    public colocadosVerdes: ColocadosVerdesComponent;
    @ViewChildren('colocadosPersonales') personalesComp : QueryList<ColocadosPersonalesComponent>;
    public colocadosPersonales: ColocadosPersonalesComponent;
    @ViewChildren('colocadosNominas') nominasComp : QueryList<ColocadosNominasComponent>;
    public colocadosNominas: ColocadosNominasComponent;
    @ViewChildren('colocadosCarburaciones') carburacionesComp : QueryList<ColocadosCarburacionesComponent>;
    public colocadosCarburaciones: ColocadosCarburacionesComponent;
    @ViewChildren('colocadosEstacionarios') estacionariosComp : QueryList<ColocadosEstacionariosComponent>;
    public colocadosEstacionarios: ColocadosEstacionariosComponent;

    public activeReport: string = null;
    public activeFilters: any = null;
    private sub: any;
    private isLoadedReportComp: boolean = false;
    private creditoToLoad: string = null;
    public subtitle: string = 'GENERAL';
    public isLoading: boolean = true;

    constructor(
        private route: ActivatedRoute,
        private changeDetector: ChangeDetectorRef,
        public reportHelper: ReportsHelperService
    ){
    }

    public ngOnInit() {
        this.sub = this.route.params.subscribe(params => {
            let credito = params['credito'];
            if(credito){
                this.setSubtitle(credito);
                this.creditoToLoad = credito;
            }
        });
    }

    public ngAfterViewInit(): void
    {
        //Este evento solo se ejecuta una vez cuando cargar el componente
        switch(this.creditoToLoad){
            case CreditosKeys.Hipotecario:
                this.hipotecarioComp.changes.subscribe(
                (comps: QueryList <ColocadosHipotecariosComponent>) => { 
                    this.colocadosHipotecario = comps.first;
                    this.isLoadedReportComp = true;
                    this.updateCustomReport(this.activeFilters);
                });
                break;
            case CreditosKeys.Automotriz:
                this.automotrizComp.changes.subscribe(
                (comps: QueryList <ColocadosAutomotricesComponent>) => { 
                    this.colocadosAutomotriz = comps.first;
                    this.isLoadedReportComp = true;
                    this.updateCustomReport(this.activeFilters);
                });
                break;
            case CreditosKeys.Prendario:
                this.prendariosComp.changes.subscribe(
                (comps: QueryList <ColocadosPrendariosComponent>) => { 
                    this.colocadosPrendarios = comps.first;
                    this.isLoadedReportComp = true;
                    this.updateCustomReport(this.activeFilters);
                });
                break;
            case CreditosKeys.Verde:
                this.verdesComp.changes.subscribe(
                (comps: QueryList <ColocadosVerdesComponent>) => { 
                    this.colocadosVerdes = comps.first;
                    this.isLoadedReportComp = true;
                    this.updateCustomReport(this.activeFilters);
                });
                break;
            case CreditosKeys.Personal:
                this.personalesComp.changes.subscribe(
                (comps: QueryList <ColocadosPersonalesComponent>) => { 
                    this.colocadosPersonales = comps.first;
                    this.isLoadedReportComp = true;
                    this.updateCustomReport(this.activeFilters);
                });
                break;
            case CreditosKeys.Nomina:
                this.nominasComp.changes.subscribe(
                (comps: QueryList <ColocadosNominasComponent>) => { 
                    this.colocadosNominas = comps.first;
                    this.isLoadedReportComp = true;
                    this.updateCustomReport(this.activeFilters);
                });
                break;
            case CreditosKeys.Carburacion:
                this.carburacionesComp.changes.subscribe(
                (comps: QueryList <ColocadosCarburacionesComponent>) => { 
                    this.colocadosCarburaciones = comps.first;
                    this.isLoadedReportComp = true;
                    this.updateCustomReport(this.activeFilters);
                });
                break;
            case CreditosKeys.Estacionario:
                this.estacionariosComp.changes.subscribe(
                (comps: QueryList <ColocadosEstacionariosComponent>) => { 
                    this.colocadosEstacionarios = comps.first;
                    this.isLoadedReportComp = true;
                    this.updateCustomReport(this.activeFilters);
                });
                break;
            default:
                //Reporte general
                this.generalComp.changes.subscribe(
                (comps: QueryList <ColocadosGeneralComponent>) => { 
                    this.colocadosGeneral = comps.first;
                    this.isLoadedReportComp = true;
                    this.updateCustomReport(this.activeFilters);
                });
                break;
        }
        
    }

    public ngAfterViewChecked()
    {
        //En este punto ya se pueden cargar los componentes de las tablas
        //Antes de este evento, se genera un error ya que el componente no tiene un estado válido
        //Esto es un comportamiento propio de Angular        
        if(!this.isLoadedReportComp && (this.activeReport !== this.creditoToLoad || this.activeReport === null)){
            //Si no se selecciono un crédito en especifico, se carga el reporte general
            this.activeReport = this.creditoToLoad ? this.creditoToLoad : 'general';
        }
        //Esta linea se necesita para que no se genere un error de Angular (originado por los ngIf del template)
        this.changeDetector.detectChanges();
    }
    
    public updateReporte(filters: any){
        if(this.isLoadedReportComp){
            this.updateCustomReport(filters);
            this.activeFilters = filters;
        }else{
            this.activeFilters = filters;
        }
    }

    private updateCustomReport(filters: any){
        this.isLoading = true;

        switch(this.creditoToLoad){
            case CreditosKeys.Hipotecario:
                this.colocadosHipotecario.updateReporte(filters);
                break;
            case CreditosKeys.Automotriz:
                this.colocadosAutomotriz.updateReporte(filters);
                break;
            case CreditosKeys.Prendario:
                this.colocadosPrendarios.updateReporte(filters);
                break;
            case CreditosKeys.Verde:
                this.colocadosVerdes.updateReporte(filters);
                break;
            case CreditosKeys.Personal:
                this.colocadosPersonales.updateReporte(filters);
                break;
            case CreditosKeys.Nomina:
                this.colocadosNominas.updateReporte(filters);
                break;
            case CreditosKeys.Carburacion:
                this.colocadosCarburaciones.updateReporte(filters);
                break;
            case CreditosKeys.Estacionario:
                this.colocadosEstacionarios.updateReporte(filters);
                break;
            default:
                //Reporte general
                if(this.colocadosGeneral){
                    this.colocadosGeneral.updateReporte(filters);
                }
                break;
        }
    }

    private setSubtitle(creditoToLoad: string){
        let infoCredito = this.reportHelper.getInfoTipoCredito(creditoToLoad);
        this.subtitle = infoCredito.label;
    }

    public onAfterLoad(){
        this.isLoading = false;
    }  
}


// WEBPACK FOOTER //
// ./src/app/reportes/creditos-colocados/reporte-colocados.component.ts